import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../firebase.config";
import { FaUserCircle } from "react-icons/fa";
import { logOutUser } from "../Redux/User/userSlice";

const Navbar = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown visibility

  return (
    <nav className="navbar">
      <a
        href="https://www.mlincsolutions.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="logo"
          alt="MLinc Solutions Logo"
          src="https://mlincsolutions.com/wp-content/uploads/2021/12/Logo.png"
        />
      </a>
      <div className="nav-container">
        <ul className="nav-ul">
          <a
            className="nav-item"
            href="https://www.mlincsolutions.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>Home</li>
          </a>
          <a
            className="nav-item"
            href="https://mlincsolutions.com/solutions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>Solutions</li>
          </a>
          <a
            className="nav-item"
            href="https://mlincsolutions.com/faq/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>FAQ</li>
          </a>
          <a
            className="nav-item"
            href="https://mlincsolutions.com/about-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>About Us</li>
          </a>
        </ul>
        <button className="nav-btn">
          <a
            href="https://mlincsolutions.com/contact-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </button>
        {user.loggedIn ? (
          <div className="profile-dropdown">
            <FaUserCircle
              size={30}
              onClick={() => {
                console.log(dropdownOpen);
                setDropdownOpen((prev) => !prev);
              }} // Toggle dropdown visibility
              className="profile-icon"
            />
            {dropdownOpen && (
              <div className="profile-menu">
                <Link
                  onClick={() => {
                    setDropdownOpen(false);
                  }}
                  to="/profile"
                  className="profile-item"
                >
                  Edit Profile
                </Link>
                <button
                  className="profile-item"
                  onClick={async () => {
                    setDropdownOpen(false);
                    await logout();
                    navigate("/");

                    dispatch(logOutUser());
                  }}
                >
                  Log Out
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link className="login-link" to="/">
            Log In
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
